.title {
	line-height: 20px;
	vertical-align: top;
	display: inline-block;
}

.avatar {
	display: inline-block;
}
